import routes from './routes'
import store from './store'

export default {
    name: 'm-audiences',
    store: store,
    routes: routes
}